import StudentErrorPage from './student-error-page'

export default StudentErrorPage
